import { CaptureSettingsDto } from '../capture-settings';
import { MerchantDto } from '../merchant.dto';

export class CaptureSettingsMerchantDto {
  id: number;
  merchantId?: number;
  captureSettingsId?: number;
  value: string;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;
  merchant?: MerchantDto;
  captureSettings?: CaptureSettingsDto;
}